import React from 'react'
import TreeFilter from 'components/TreeSelectFilter'
import { Row } from 'antd'

const SkillsFilter = ({ filterOptions, filterValues,  handleFilterChange,handleFilterSearch}) => {
  // Convert the API format to the format expected by TreeSelect component

  return (
    <Row style={{ margin: 10, rowGap: '0px !important' }}>
    <TreeFilter
    placeholder="Search and Select Skills"
    treeData={filterOptions.skillList}
    value={filterValues.selectedSkills}
    onChange={handleFilterChange}
    onSearch={handleFilterSearch}
    valueKey='selectedSkills'
    />
    </Row>
  )
}

export default SkillsFilter
